export default __webpack_public_path__ + "static/avatar-simon-james-5fbb0a31c0125ab18eb07a2b238eade7.jpeg";